import request from '@/utils/http'

const PREFIX = '/audit'

const applicationAudit = {
  apply(params) {
    return request(
      `${PREFIX}/apply`,
      'post',
      params
    )
  },

  through(id) {
    return request(
      `${PREFIX}/through/${id}`,
      'put',
    )
  },

  revoke(id) {
    return request(
      `${PREFIX}/cancel/${id}`,
      'put',
    )
  },

  page(params) {
    return request(
      `${PREFIX}`,
      'get',
      params
    )
  }
}

export default applicationAudit
